/* eslint-disable menti-react/filename-convention--jsx */
import { useRagnar } from '@mentimeter/ragnar-react';
import { ArrowRight } from '@mentimeter/ragnar-visuals';
import { Text } from '@mentimeter/ragnar-ui/text';
import { TitleSectionWithImage } from '../../ui/Components/VotingTitle';
import { useAppSelector } from '../../redux-hooks';
import { paceModeSelector } from '../../selectors';
import { useTranslate } from '../../features/localization/Translate';
import type { ModuleComponentProps } from '../types';

export function Content({ question }: ModuleComponentProps) {
  const translate = useTranslate();
  const { theme } = useRagnar();

  const pace = useAppSelector(paceModeSelector);
  const isAudiencePace = pace === 'audience';

  return (
    <>
      <ArrowRight userColor={theme.colors.positive} />
      {isAudiencePace ? (
        <TitleSectionWithImage
          title={question.question}
          titleStyled={question.question_styled}
        />
      ) : (
        <>
          <Text fontSize="175" mt="space6" mb="space3">
            {translate('instructions.title')}
          </Text>
          <Text fontSize="100"> {translate('instructions.subtitle')}</Text>
        </>
      )}
    </>
  );
}
